// The verdict a research conclusion opens with ("KILL: the carry's only…",
// "YES, medium confidence: carry …", "ITERATE (medium confidence): of
// eight…", "GO — the install works…"), taken off for display. The agents
// write their conclusions verdict first; the screens show the finding
// (2026-10-11: a page of "YES / PASS / KILL" read as shouting and said
// nothing the sentence does not). Only a leading run of capitals holding a
// known verdict word counts ("SPY, QQQ and IWM …" is no verdict, nor "ORB
// replicates …"). Pure; activity.selftest.ts.

const VERDICT_WORDS = new Set([
  "GO", "YES", "PASS", "PASSES", "ADOPT", "REPLICATES", "PROCEED", "KEEP", "BUY", "ACCEPT", "INVEST", "DEPLOY", "SHIP",
  "CONFIRMED", "SUPPORTED", "PROMISING", "GREEN", "RAISE", "TRADE", "APPROVE",
  "ITERATE", "WATCH", "HOLD", "REDUCE", "INCONCLUSIVE", "PARTIAL", "MIXED", "REVISE", "MONITOR", "AMBER", "PAUSE", "RETEST", "REFINE",
  "NO", "NOT", "KILL", "DROP", "CUT", "FAIL", "FAILS", "REJECT", "STOP", "SELL", "AVOID", "REFUTED", "RED", "ABANDON", "NO-GO",
]);

const LEAD = /^([A-Z][A-Z'’-]*(?: [A-Z][A-Z'’-]*){0,3})(?=\s*(?:[:,;.(—–]|\s-\s|$))/;
const CONFIDENCE = /^(?:\(([^)]{1,80})\)|((?:very |fairly )?(?:low|medium|moderate|high|moderate-high|low-medium|medium-high)[- ]confidence(?:, [^:;.]{1,30})?))\s*[:;,.]?\s*/i;

/**
 * A conclusion as the screens show it: without the verdict word and the
 * confidence label it opens with, the finding's first letter capitalised
 * ("YES, medium confidence: carry 207,893 USD …" → "Carry 207,893 USD …").
 * Line breaks are kept. Unchanged when it opens with no verdict, or when
 * nothing would be left.
 */
export function plainConclusion(conclusion: string | null | undefined): string {
  const text = (conclusion ?? "").trim();
  const m = LEAD.exec(text);
  if (!m || m[1].length < 2 || !m[1].split(" ").some((w) => VERDICT_WORDS.has(w))) return text;
  let rest = text.slice(m[1].length).replace(/^\s*(?:[:,;.—–-]\s*)?/, "");
  const c = CONFIDENCE.exec(rest);
  if (c) rest = rest.slice(c[0].length);
  return rest ? rest.charAt(0).toUpperCase() + rest.slice(1) : text;
}
